export default "__VITE_ASSET__DAVDzPMR__"